export default {
    "breakPointXL": "1400px",
    "breakPointL": "1200px",
    "breakPointM": "1000px",
    "breakPointS": "800px",
    "breakPointXS": "500px",
    "breakPointXXS": "400px",
    "contentBreakPointXXS": "400px",
    "contentBreakPointXS": "500px",
    "contentBreakPointS": "650px",
    "contentBreakPointM": "900px",
    "contentBreakPointL": "1000px",
    "contentBreakPointXL": "1200px",
    "clippyWidth": "360px",
    "breakPointClippy": "1360px",
    "breakPointHideMenu": "800px",
    "breakPointHeightTestDrive": "790px",
    "breakPointHeightTestDrive2": "700px"
}
